import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './block-company.scss';

class BlockCompany extends PureComponent {
  render() {
    return (
      <div className="draft-js-block block-company">
        <div className="draft-js-container">
          <div className="draft-js-content">
            <h4>Справка о компании</h4>

            {(this.props.companyLogo) &&
              <img src={this.props.companyLogo} alt="Логотип компании" />
            }

            <p dangerouslySetInnerHTML={{ __html: this.props.companyText }} />
          </div>
        </div>
      </div>
    );
  }
}

BlockCompany.propTypes = {
  companyLogo: PropTypes.string,
  companyText: PropTypes.string
};

export default BlockCompany;



// WEBPACK FOOTER //
// ./src/components/widgets/StaticRenderer/BlockCompany.js